<script>


    const DIRECTIONMAP = {
        vertical: {
            eventVal: 'offsetY',
            direction: 'vertical',
            offset: 'offsetHeight',
            size: 'height',
            scrollSize: 'scrollHeight',
            scroll: 'scrollTop',
            axis: 'top',
            client: 'clientY',
            clientSize: 'clientHeight',
        },
        horizontal: {
            eventVal: 'offsetX',
            direction: 'horizontal',
            offset: 'offsetWidth',
            size: 'width',
            scrollSize: 'scrollWidth',
            scroll: 'scrollLeft',
            axis: 'left',
            client: 'clientX',
            clientSize: 'clientWidth',
        }
    };

    export default {
        name: 'NormalScrollbar',
        data () {
            return {
                scrollStyle: {
                    verticalThumbHeight: 0,
                    verticalBarOpacity: 0,
                    scrollTop: 0,
                    horizontalThumbHeight: 0,
                    horizontalBarOpacity: 0,
                    scrollLeft: 0,
                    horizontal: false,
                    vertical: true,
                    canDrag: false,
                    verticalOffset: 0,
                    horizontalOffset: 0
                },
                curMap: {},
                resetScrollTimer: null
            };
        },
        props: {
            barSize: {
                type: Number,
                required: false,
                default: 6
            },
            height: {
                type: Number,
                required: false
            },
            width: {
                type: Number,
                required: false
            }
        },
        computed: {
            computeScrollBarStyle () {
                return {
                    maxWidth: `${ this.width || '' }px`,
                    maxHeight: `${ this.height || '' }px`
                };
            },
            computeScrollWrapStyle () {
                const scrollbarWidth = this.$util.getScrollBarWidth();

                return {
                    maxWidth: `${ this.width ? Number(this.width) + scrollbarWidth : '' }px`,
                    maxHeight: `${ this.height ? Number(this.height) + scrollbarWidth : '' }px`,
                    marginRight: `${ -scrollbarWidth }px`,
                    marginBottom: `${ -scrollbarWidth }px`
                };
            },
            computeVerticalThumbStyle () {
                return {
                    height: this.scrollStyle.verticalThumbHeight * 100 + '%',
                    top: `${ this.scrollStyle.scrollTop }px`
                };
            },
            computeVerticalBarStyle () {
                return {
                    opacity: this.scrollStyle.verticalBarOpacity,
                    width: `${this.barSize}px`
                };
            },
            computeHorizontalThumbStyle () {
                return {
                    width: this.scrollStyle.horizontalThumbHeight * 100 + '%',
                    left: `${ this.scrollStyle.scrollLeft }px`
                };
            },
            computeHorizontalBarStyle () {
                return {
                    opacity: this.scrollStyle.horizontalBarOpacity,
                    height: `${this.barSize}px`
                };
            }
        },
        methods: {
            scrollBarShowOrHide (direction) {
                const {scrollBar, scrollWrap} = this.$refs;
                const map = DIRECTIONMAP[direction];
                const barLen = this.$refs[`${ direction }Bar`][map.clientSize];
                const viewLen = scrollWrap[map.scrollSize];
                this.scrollStyle[`${ direction }ScrollBarHeight`] = barLen;
                let height = (barLen - 4) / viewLen;
                let heightPx = barLen * height;
                if (heightPx < 20) {
                    height = 20 / barLen;
                }
                this.scrollStyle[`${ direction }ThumbHeight`] = height;
                this.scrollStyle[`${ direction }BarOpacity`] = 1;
                this.$nextTick(() => {
                    this.scrollStyle[`${ direction }Offset`] =
                        (scrollWrap[map.scrollSize] - scrollBar[map.offset]) /
                        (
                            this.$refs[`${ direction }Bar`][map.offset] -
                            this.$refs[`${ direction }Thumb`][map.offset]
                        );
                });
            },
            setScrollProps () {
                const {scrollBar, scrollView, scrollWrap} = this.$refs;
                if (!scrollBar || !scrollView) {
                    return;
                }
                const scrollViewRect = scrollView.getBoundingClientRect();
                const scrollBarRect = scrollBar.getBoundingClientRect();
                this.scrollStyle.isEnter = true;
                this.scrollStyle.vertical = scrollBarRect.height < scrollViewRect.height;
                this.scrollStyle.horizontal = scrollWrap.scrollWidth - scrollBarRect.width > 1;
                this.scrollStyle.vertical && this.scrollBarShowOrHide('vertical');
                this.scrollStyle.horizontal && this.scrollBarShowOrHide('horizontal');
            },
            resetScrollProps ($e) {
                try {
                    this.cancelScrollTimer();
                    if (this.scrollStyle.canDrag) {
                        return;
                    }
                    this.resetScrollTimer = setInterval(() => {
                        this.setScrollProps();
                        !this.scrollStyle.vertical && (this.scrollStyle.verticalBarOpacity = 0);
                        !this.scrollStyle.horizontal && (this.scrollStyle.horizontalBarOpacity = 0);
                    }, 250);
                } catch (e) {
                    this.cancelScrollTimer();
                }
            },
            cancelScrollTimer () {
                if (this.resetScrollTimer) {
                    clearTimeout(this.resetScrollTimer);
                    this.resetScrollTimer = null;
                }
            },
            cancelScrollProps () {
                this.scrollStyle.isEnter = false;
                if (this.scrollStyle.canDrag) {
                    return;
                }
                this.scrollStyle.verticalBarOpacity = 0;
                this.scrollStyle.horizontalBarOpacity = 0;
                this.scrollStyle.direction && (this.scrollStyle.canDrag = false);
                this.scrollStyle.vertical && (this.scrollStyle.canDrag = false);
                this.cancelScrollTimer();
            },
            clickTrackHandler (e, direction) {
                this.curMap = DIRECTIONMAP[direction];
                const {offset} = this.curMap;
                const {scrollWrap} = this.$refs;
                if (this.scrollStyle[direction]) {
                    const $thumb = this.$refs[`${ direction }Thumb`];
                    $thumb.style.transition = 'all .12s ease';
                    const scrollStep = this.scrollStyle[`${ direction }Offset`];
                    const thumbHalf = $thumb[offset] / 2;
                    const limit = this.scrollStyle[`${ this.curMap.direction }ScrollBarHeight`] - this.$refs[`${ direction }Thumb`][this.curMap.offset] - 4;
                    let thumbPosition = e[this.curMap.eventVal] - thumbHalf;
                    thumbPosition = thumbPosition < 0 ? 0 : (thumbPosition > limit ? limit : thumbPosition);
                    const scrollHeight = scrollStep * thumbPosition;
                    this.scrollStyle[this.curMap.scroll] = thumbPosition;
                    scrollWrap[this.curMap.scroll] = scrollHeight;
                }
            },
            handlerMouseDown (e, direction) {
                // this.$refs[`${direction}Thumb`].style.transition = 'opacity .12s ease';
                const {scrollWrap, scrollBar} = this.$refs;
                const map = this.curMap = DIRECTIONMAP[direction];
                const offset = e[this.curMap.eventVal];
                const canDrag = this.scrollStyle[direction];
                this.scrollStyle[`${ direction }Offset`] = (scrollWrap[map.scrollSize] - scrollBar[map.offset]) / (this.$refs[`${ direction }Bar`][map.offset] - this.$refs[`${ direction }Thumb`][map.offset] - 4);
                if (canDrag) {
                    this.scrollStyle[`${ direction }Drag`] = offset;
                    this.scrollStyle.canDrag = true;

                    document.addEventListener('mousemove', this.handlerMouseMove);
                    document.addEventListener('mouseup', this.handlerMouseUp);
                    document.onselectstart = () => false;
                }
            },
            handlerMouseMove (e) {
                const {scrollWrap} = this.$refs;
                let {direction, axis, offset, client} = this.curMap;
                const {canDrag} = this.scrollStyle;
                const limit = this.scrollStyle[`${ this.curMap.direction }ScrollBarHeight`] - this.$refs[`${ direction }Thumb`][offset] - 4;
                if (!canDrag) {
                    return;
                }
                const scrollStep = this.scrollStyle[`${ direction }Offset`];
                let thumbPosition = ((this.$refs[`${ direction }Bar`].getBoundingClientRect()[axis] - e[client]) * -1) - this.scrollStyle[`${ direction }Drag`];
                thumbPosition = thumbPosition < 0 ? 0 : (thumbPosition > limit ? limit : thumbPosition);
                const scrollHeight = scrollStep * thumbPosition;
                this.scrollStyle[this.curMap.scroll] = thumbPosition;
                scrollWrap[this.curMap.scroll] = scrollHeight;
            },
            handlerMouseUp () {
                document.removeEventListener('mouseup', this.handlerMouseUp);
                document.removeEventListener('mousemove', this.handlerMouseMove);
                document.onselectstart = null;
                this.scrollStyle.canDrag = false;
                !this.scrollStyle.isEnter && this.cancelScrollProps();
            },
            handlerScroll (e) {
                this.$nextTick(() => {
                    this.$emit('scroll', this.scrollStyle);
                });
                if (this.scrollStyle.canDrag) {
                    return;
                }
                e.stopPropagation();
                e.preventDefault();
                const {scrollWrap} = this.$refs;
                this.scrollStyle.scrollTop = ((scrollWrap.scrollTop) / this.scrollStyle.verticalOffset);
                this.scrollStyle.scrollLeft = ((scrollWrap.scrollLeft) / this.scrollStyle.horizontalOffset);
            },
            getWrap () {
                return this.$refs.scrollWrap;
            }

        },
        mounted () {
        }
    };
</script>

<template>
    <div class="normal-scrollbar"
         ref="scrollBar"
         :style="computeScrollBarStyle"
         @mouseleave="cancelScrollProps"
         @mousemove="resetScrollProps"
         @mouseenter="setScrollProps">
        <div class="normal-scrollbar__wrap"
             ref="scrollWrap"
             @scroll.stop="handlerScroll"
             :style="computeScrollWrapStyle">
            <div class="normal-scrollbar__view"
                 ref="scrollView">
                <slot></slot>
            </div>
        </div>
        <div class="normal-scrollbar__bar is-horizontal"
             :style="computeHorizontalBarStyle"
             @mousedown.stop="clickTrackHandler($event, 'horizontal')"
             ref="horizontalBar">
            <div class="normal-scrollbar__thumb"
                 :style="computeHorizontalThumbStyle"
                 @mousedown.stop="handlerMouseDown($event, 'horizontal')"
                 ref="horizontalThumb"></div>
        </div>
        <div class="normal-scrollbar__bar is-vertical"
             :style="computeVerticalBarStyle"
             @mousedown.stop="clickTrackHandler($event, 'vertical')"
             ref="verticalBar">
            <div class="normal-scrollbar__thumb"
                 ref="verticalThumb"
                 @mousedown.stop="handlerMouseDown($event, 'vertical')"
                 :style="computeVerticalThumbStyle"></div>
        </div>
    </div>
</template>

<style scoped lang="less">
    .normal-scrollbar {
        overflow: hidden;
        position: relative;

        &__wrap {
            overflow: scroll;

        }

        &__bar {
            position: absolute;
            right: 2px;
            bottom: 2px;
            z-index: 1;
            border-radius: 4px;
            opacity: 0;
            transition: opacity .1s ease;


            &.is-vertical {
                width: 6px;
                top: 2px;

                > div {
                    width: 100%;
                }
            }

            &.is-horizontal {
                height: 6px;
                left: 2px;

                > div {
                    height: 100%;
                }
            }
        }

        &__thumb {
            position: relative;
            display: block;
            width: 0;
            height: 0;
            cursor: pointer;
            border-radius: inherit;
            background-color: #dedfe0;
            transition: opacity .12s ease;
        }
    }
</style>
